import { Injectable } from "@angular/core";

import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "@api/common/api-endpoints";
import {
  PageResultDto,
  OfflineTenantVoucherCodeDto,
  FindOfflineTenantVoucherListOfCodesDto,
} from "@api/dto";

@Injectable({
  providedIn: "root",
})
export class OfflineTenantVoucherListOfCodesService {
  constructor(private httpService: HttpService) {}

  async find(
    id: string,
    findOfflineTenantVoucherListOfCodesDto: FindOfflineTenantVoucherListOfCodesDto
  ) {
    if (!id?.trim()) {
      throw new Error("ID parameter is required and cannot be empty");
    }

    const endpoint =
      ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER_LIST_OF_CODES.replace(
        ":id",
        encodeURIComponent(id.trim())
      );
    try {
      return await this.httpService.get<
        PageResultDto<OfflineTenantVoucherCodeDto>
      >(endpoint, findOfflineTenantVoucherListOfCodesDto);
    } catch (error) {
      console.error("Failed to fetch offline tenant voucher codes:", error);
      throw error;
    }
  }

  async export(id: string, filters?: FindOfflineTenantVoucherListOfCodesDto) {
    if (!id?.trim()) {
      throw new Error("ID parameter is required and cannot be empty");
    }

    const endpoint =
      ADMIN_API_ENDPOINTS.OFFLINE_TENANT_VOUCHER_LIST_OF_CODES_EXPORT.replace(
        ":id",
        encodeURIComponent(id.trim())
      );
    try {
      return await this.httpService.downloadBlob<Blob>(endpoint, filters);
    } catch (error) {
      console.error("Failed to export offline tenant voucher codes:", error);
      throw error;
    }
  }
}
